export function servicesAccordion() {
	const toggles = document.querySelectorAll('.services__toggle');
	if (!toggles.length) return;

	toggles.forEach((toggle) => {
		toggle.addEventListener('click', () => {
			const accordion = toggle.nextElementSibling;
			if (!accordion) return;

			const isActive = accordion.classList.contains('active');

			if (isActive) {
				accordion.classList.remove('active');
				toggle.classList.remove('active');
			} else {
				accordion.classList.add('active');
				toggle.classList.add('active');
			}
		});
	});
}
